import {
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { PaginationDTO } from 'src/app/common/types/responses/responses-template';
import { ProformViewStates } from '../../../dtos/proforms.dto';
import { ProFormsModalDisplay } from '../../../enums/proforms.enum';
import { ProformsFormListService } from '../../../services/proforms/proforms-formlist.service';
import { ProFormsSubmissionAPIResponse } from '../../../types/responses/proforms.responses';
import { ModalComponent } from '../../modals/modal/modal.component';

@Component({
  selector: 'app-proforms-submissions-modal',
  standalone: false,

  templateUrl: './proforms-submissions-modal.component.html',
  styleUrl: './proforms-submissions-modal.component.scss',
})
export class ProformsSubmissionsModalComponent
  implements OnInit, OnChanges, OnDestroy
{
  @ViewChild('modal') modal: ModalComponent;

  @Input() formId: number;

  @Input() formTitle: string;

  @Input() isQuiz: boolean;

  subs: Subscription[] = [];

  display: ProFormsModalDisplay;

  submissionData: ProFormsSubmissionAPIResponse[] = [];

  currentSubmission: ProFormsSubmissionAPIResponse | undefined;

  currentSubmissionIdx = 0;

  modalDisplays = ProFormsModalDisplay;

  submissionsLoading: boolean;

  isLoading: boolean;

  pagination: PaginationDTO;

  totalSubmissions = 0;

  currentPage = 1;

  viewStates = ProformViewStates;

  constructor(private proformsFormListService: ProformsFormListService) {}

  ngOnInit() {
    this.display = ProFormsModalDisplay.LIST;
    if (this.formId) {
      this.loadSubmissions();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['formId']) {
      this.loadSubmissions();
    }
  }

  loadSubmissions(showSubmissionIdx?: number) {
    this.submissionsLoading = true;
    if (this.formId) {
      this.subs.push(
        this.proformsFormListService
          .getFormSubmissions(this.formId, this.currentPage)
          .subscribe((resp) => {
            this.submissionData = resp.items;
            this.pagination = resp._meta;
            if (showSubmissionIdx !== undefined) {
              this.showSubmissionDetails(
                this.submissionData[showSubmissionIdx]
              );
            }
            this.submissionsLoading = false;
          })
      );
    }
  }

  pageChange(newPage: number) {
    this.currentPage = newPage;
    this.loadSubmissions();
  }

  showSubmissionDetails(submission: ProFormsSubmissionAPIResponse) {
    this.display = ProFormsModalDisplay.SUBMISSION;
    this.currentSubmission = submission;
    // get index of submission - takes current page into account to display the correct number for user.
    this.currentSubmissionIdx =
      (this.currentPage - 1) * 10 + this.submissionData.indexOf(submission);
  }

  goToSubmission(direction: 'next' | 'previous') {
    this.isLoading = true;
    if (direction === 'next') {
      this.currentSubmissionIdx += 1;
      if (this.currentSubmissionIdx % 10 === 0) {
        this.currentPage += 1;
      }
    } else {
      this.currentSubmissionIdx -= 1;
      if (this.currentSubmissionIdx % 10 === 9) {
        this.currentPage -= 1;
      }
    }
    const submissionToDisplay = this.currentSubmissionIdx % 10;

    if (this.currentPage === this.pagination.currentPage) {
      this.showSubmissionDetails(this.submissionData[submissionToDisplay]);
    } else {
      this.loadSubmissions(submissionToDisplay);
    }
  }

  viewAllSubmissions() {
    this.display = ProFormsModalDisplay.LIST;
    this.currentPage = 1;
    this.currentSubmissionIdx = 0;
    this.loadSubmissions();
  }

  // eslint-disable-next-line class-methods-use-this
  openSession(submission: ProFormsSubmissionAPIResponse) {
    window.open(`/training/session/${submission.context_table_id}`, '_blank');
  }

  resetModal() {
    this.currentSubmissionIdx = 0;
    this.currentSubmission = undefined;
    this.display = ProFormsModalDisplay.LIST;
  }

  ngOnDestroy(): void {
    let sub = this.subs.pop();
    while (sub) {
      sub.unsubscribe();
      sub = this.subs.pop();
    }

    if (this.modal) {
      this.modal.close();
    }
  }
}
